export const HighchartHelper = {
  tooltipTemplate: (overwrite = {}) => {
    return Object.assign({
      shadow: true,
      enabled: true,
      style: {
        fontSize: '1.8rem',
        fontWeight: 'normal',
        color: '#000',
        zIndex: 3
      },
      useHtml: true,
      //backgroundColor: '#fff',
      borderWidth: null,
      borderRadius: 5,
      outside: true,
      headerFormat: '<span class="h4">{point.y:.1f} %</span><br>',
      pointFormat: '<span>{point.name}</span>',
      /*
      formatter: function () {
        console.log(this.point);
        
        return `<b class="h4">${this.point.percentage.toFixed(1)}%</b><br />${this.point.name}`
  
      }
      */
    }, overwrite)
  }
}